<template>
  <header class="mhero">
    <button
      v-if="showBack"
      class="mhero__back"
      type="button"
      @click="$emit('back')"
    >
      <i class="mdi mdi-arrow-left"></i> {{ $t("course.backToModules") }}
    </button>

    <p class="mhero__eyebrow">
      <span class="mhero__dot" :style="{ background: accent }"></span>
      {{ eyebrow }}
    </p>
    <h1 class="mhero__title">
      {{ module.title || $t("course.untitledModule") }}
    </h1>
    <p v-if="module.description" class="mhero__sub">{{ module.description }}</p>

    <span v-if="badge" class="mhero__badge" :style="{ '--accent': accent }">
      <i class="mdi mdi-stairs-up"></i> {{ badge }}
    </span>
  </header>
</template>

<script>
import {
  tierColor,
  tierLabel,
  isTrainingModule,
  TRAINING_COLOR,
} from "@/shared/courseTiers";

export default {
  name: "ModuleHero",
  props: {
    // Modulo (level, title, description)
    module: { type: Object, required: true },
    // Selo opcional (ex.: "Seu nível atual" para aluno vinculado)
    badge: { type: String, default: "" },
    // Botao voltar (grades de modulo)
    showBack: { type: Boolean, default: false },
  },
  computed: {
    lvl() {
      const n = Number(this.module.level);
      return Number.isFinite(n) ? n : 0;
    },
    // Card 86akptec0: treinamento de professor não é degrau da escada.
    isTraining() {
      return isTrainingModule(this.module);
    },
    accent() {
      return this.isTraining ? TRAINING_COLOR : tierColor(this.lvl);
    },
    eyebrow() {
      if (this.isTraining) return this.$t("course.trainingEyebrow");
      return this.$t("course.moduleEyebrow", {
        tier: tierLabel(this.lvl),
        number: String(this.lvl).padStart(2, "0"),
      });
    },
  },
};
</script>

<style scoped>
.mhero {
  padding-bottom: 24px;
  margin-bottom: 26px;
  border-bottom: 1px solid var(--dk-line, #eae7f0);
  font-family: "Poppins", sans-serif;
}
.mhero__back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 18px;
  border: 0;
  background: transparent;
  font-family: "Poppins", sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--dk-ink-soft, #6e6a79);
  cursor: pointer;
  padding: 4px 0;
  transition: color 0.18s ease;
}
.mhero__back:hover {
  color: var(--dk-ink, #211b2e);
}
.mhero__back .mdi {
  font-size: 18px;
}
.mhero__back:focus-visible {
  outline: 2px solid var(--dk-pink, #e8276f);
  outline-offset: 2px;
  border-radius: 4px;
}
.mhero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.mhero__dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}
.mhero__title {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  line-height: 1;
  letter-spacing: -0.015em;
  color: var(--dk-ink, #211b2e);
  overflow-wrap: anywhere;
}
.mhero__sub {
  margin: 12px 0 0;
  max-width: 56ch;
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--dk-ink-soft, #6e6a79);
}
.mhero__badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  padding: 7px 14px;
  border-radius: 999px;
  background: var(--dk-surface, #fff);
  border: 1px solid var(--dk-line-strong, #ded9e8);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dk-ink-soft, #6e6a79);
}
.mhero__badge .mdi {
  color: var(--accent, var(--dk-pink, #e8276f));
  font-size: 16px;
}
</style>
